import { useContext } from "react";

import EditClass from "../../EditClass/EditClass";

import { listControllerContext } from "../../../../contextAdmin/Admin/List";
import { popupContext } from "../../../../contextAdmin/Admin/Popup";

import styles from "../style.module.css"
import EditTeacher from "../../EditTeacher/EditTeacher";
import editIcon from "../TablePng/edit-2.svg"
import trashIcon from "../TablePng/trash-2.svg"

export default function TeacherRow(props) {
  const user = props.value;
  const { setPopup } = useContext(popupContext);

  const sumStudents = user?.classes?.reduce((acc, curr) => { acc += curr?.students?.length; return acc }, 0)

  const openEditTeacherPopUp = () => {
    setPopup(
      <EditTeacher type={"Edit Teacher"} user_id={user.id} firstName={user.firstName} permissions={user.permissions} email={user.email}>
        Edit teacher
      </EditTeacher>
    );
  }

  const deleteTeacher = () => {
    setPopup(
      <EditTeacher type={"Delete Teacher"} user_id={user.id} firstName={user.firstName} permissions={user.permissions} email={user.email}>
        Delete teacher
      </EditTeacher>
    );
  }

  return (
    <>

      <div className={styles["rowBox"]}>
        <div className={styles["rows"]}>
          <div title={user.firstName} className={styles["text_row"]}>{user.firstName}</div>
          <div title={user.email} className={styles["text_row"]}>{user.email}</div>
          <div title={user.permissions} className={styles["text_row"]}>{user.permissions}</div>
          <div title={user.classes?.length} className={styles["text_row_as_number"]}>{user.classes?.length}</div>
          <div title={sumStudents} className={styles["text_row_as_number"]}>{sumStudents}</div>
          <div className={`${styles["text_row"]} ${styles["buttons"]}`}>
            <div onClick={openEditTeacherPopUp}>
              <img src={editIcon} alt="Edit" />
            </div>
            <div onClick={deleteTeacher}            >
              <img src={trashIcon} alt="Delete" />
            </div>
          </div>
        </div>
      </div>

    </>
  );
}
